'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFileAttachments = undefined;

var _immutable = require('immutable');

var _fileUploadGetters = require('conversations-internal-schema/file-upload/operators/fileUploadGetters');

var _isUploadCompleted = require('conversations-internal-schema/file-upload/operators/isUploadCompleted');

var _FileAttachment = require('conversations-schema/common-message-format/records/FileAttachment');

var _FileAttachment2 = _interopRequireDefault(_FileAttachment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  * @param {List<FileUploadRecord>} fileUploads
  * @returns {List<FileAttachment>} a list of size one
*/
var buildFileAttachments = exports.buildFileAttachments = function buildFileAttachments(fileUploads) {
  if (!fileUploads) {
    return (0, _immutable.List)();
  }

  var fileIds = fileUploads.filter(_isUploadCompleted.isUploadCompleted).map(_fileUploadGetters.getFileId);

  if (!fileIds.size) {
    return (0, _immutable.List)();
  }

  return (0, _immutable.List)([(0, _FileAttachment2.default)({
    fileIds: fileIds
  })]);
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/operators/buildFileAttachments.js
// module id = 651
// module chunks = 2 3